
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHdGrid extends Serenity.EntityGrid<PsAdvPromoHdRow, any> {
        protected getColumnsKey() { return PsAdvPromoHdColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHdDialog; }
        protected getIdProperty() { return PsAdvPromoHdRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHdRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHdRow.localTextPrefix; }
        protected getService() { return PsAdvPromoHdService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            let filters = super.getQuickFilters();
            
            filters.push({
                field: 'PromoStatus',
                type: Serenity.IntegerEditor,
                title: 'สถานะ',
                handler: h => {
                    h.value = 0;
                    h.active = true;
                    h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                        [['PromoStatus'], '=', 0]
                    );
                }
            });

            return filters;
        }
    }
}